// Remove extra whitespace generated by ReactDOMServer
export const trimWhitespace = (rawHtml: string): string =>
  rawHtml.replaceAll(/\r\n|[\t\n\r]/g, '');
